import {Link} from "react-router-dom";

export function Footer () {
    return <div className={"w-full flex flex-col items-center max-w-[90vw] gap-2 m-8 mt-24"}>
        <EmojiBar />
        <div className={"flex flex-row items-center gap-2"}>
            <Link to={"/imprint"} className={"hover:text-secondary transition-all underline"}>Imprint</Link>
            <span className={"text-foreground/30"}>-</span>
            <div className={"text-foreground/30 text-sm"}>portfolio site designed by <a className={"hover:text-secondary transition-all underline hover:italic"} href={"https://mbruder.com"}>Moritz Bruder</a></div>
        </div>
    </div>
}

function EmojiBar () {
    const emojis: string[] = [
        "🏃",
        "🚴",
        "🎧",
        "🎥",
        "📸",
    ]
    return <div className={"cursor-default flex flex-row items-center gap-4"}>
        { emojis.map((emoji) => (
            <div key={emoji} className={"opacity-65 transition-all duration-500 hover:opacity-100"}>{emoji}</div>
        ))}
    </div>
}